
import {InterfacePlatformDocument} from "./InterfacePlatformDocument";

/**
 * 挿入するドキュメントがない場合のストラテジー
 */
export class NullPlatformDocument implements InterfacePlatformDocument {
    /**
     * @inheritDoc
     */
    public async append(resourceUrl: string): Promise<Document> {
        // 空のドキュメントを作成する
        return document.implementation.createDocument(null, null, null);
    }

    /**
     * @inheritDoc
     */
    public convertHtmlPathToResourceUrl(htmlPath: string): string {
        return "";
    }
}